// App.js
import React, {useEffect, useState} from 'react';

import LessonContent from './LessonContent';
import LessonSelector from './LessonSelector';
import ToneDrillLesson from './ToneDrillLesson';

const App = () => {
  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState(null);

  useEffect(() => {
    // Fetch the list of lessons
    fetch('/static/lessons.json')
      .then((response) => response.json())
      .then((data) => setLessons(data))
      .catch((error) => console.error('error fetching lessons:', error));
  }, []);

const renderContent = () => {
    if (!selectedLesson) {
      return <LessonSelector lessons={lessons} onSelectLesson={setSelectedLesson} />;
    }
    if (selectedLesson.name === 'Pitch Shift') {
      return <ToneDrillLesson selectedLesson={selectedLesson} onBack={() => setSelectedLesson(null)} />;
    }

    // Default rendering for other lessons
    return <LessonContent selectedLesson={selectedLesson} onBack={() => setSelectedLesson(null)} />;
  };

  return (
    <div style={styles.container}>
      {renderContent()}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
};

export default App;
